import { createSlice } from "@reduxjs/toolkit";
import { groupResultsByType, normalizeModuleTotals, normalizeType } from "./categories";

const emptyInternalData = {
  pagination: {
    skip: 0,
    limit: 10
  },
  isLoading: false,
  isLoadingMore: false,
  isLoadingCategory: false,
  columnNames: [],
  list: [],
  resultsByCategory: {},
  fetchedByCategory: {},
  moduleTotals: {},
  totalCount: 0
};

export const appUniversalSearchSlice = createSlice({
  name: "app-universal-search",
  initialState: {
    isFetched: false,
    internalData: { ...emptyInternalData }
  },
  reducers: {
    onCallAppInternalSearch: (state, { payload } = {}) => {
      const append = payload?.append;
      const category = payload?.category;
      state.internalData.isLoadingMore = !!append;
      state.internalData.isLoadingCategory = !append && !!category;
      state.internalData.isLoading = !append && !category;

      if (!append && !category) {
        state.internalData.columnNames = [];
        state.internalData.list = [];
        state.internalData.resultsByCategory = {};
        state.internalData.fetchedByCategory = {};
        state.internalData.moduleTotals = {};
        state.internalData.totalCount = 0;
      }
    },
    onSuccessInternalSearch: (state, { payload } = {}) => {
      const data = payload?.data || payload || {};
      const tableData = data.tableData || [];
      const append = payload?.append;
      const category = payload?.category;
      const moduleTotals = normalizeModuleTotals(data.module_totals);

      state.internalData.list = tableData;
      state.internalData.columnNames = data.columnNames || [];
      state.internalData.isLoading = false;
      state.internalData.isLoadingMore = false;
      state.internalData.isLoadingCategory = false;

      if (!category) {
        state.internalData.totalCount = parseInt(data.total_count, 10) || 0;
      }

      if (Object.keys(moduleTotals).length) {
        if (category) {
          Object.assign(state.internalData.moduleTotals, moduleTotals);
        } else {
          state.internalData.moduleTotals = moduleTotals;
        }
      }

      if (category) {
        const type = normalizeType(category);
        const existing = state.internalData.resultsByCategory[type] || [];
        state.internalData.resultsByCategory[type] = append ? [...existing, ...tableData] : tableData;
        state.internalData.fetchedByCategory[type] = true;
        return;
      }

      const grouped = groupResultsByType(tableData);
      state.internalData.resultsByCategory = grouped;
      state.internalData.fetchedByCategory = {};
      if (!Object.keys(moduleTotals).length) {
        state.internalData.moduleTotals = Object.keys(grouped).reduce((acc, type) => {
          acc[type] = grouped[type].length;
          return acc;
        }, {});
      }
    },
    onFailedInternalSearch: (state) => {
      state.internalData.isLoading = false;
      state.internalData.isLoadingMore = false;
      state.internalData.isLoadingCategory = false;
    },
    onCallAppInternalSearchPromise: (state, { payload }) => {
      state.internalData.pagination = {
        skip: payload?.skip || 0,
        limit: payload?.limit || 10
      };
    },
    onSuccessAppInternalSearchPromise: (state, { payload }) => {
      const data = payload || {};
      state.internalData.list = data.tableData || [];
      state.internalData.totalCount = parseInt(data.total_count, 10) || 0;
      state.internalData.columnNames = data.columnNames || [];
    }
  }
});

export const {
  onCallAppInternalSearch,
  onSuccessInternalSearch,
  onFailedInternalSearch,

  onSuccessAppInternalSearchPromise,
  onCallAppInternalSearchPromise
} = appUniversalSearchSlice.actions;

export default appUniversalSearchSlice.reducer;
